// extracted by mini-css-extract-plugin
export default {"frag_layout":"Fragrances_frag_layout__avQeJ","empty__note":"Fragrances_empty__note__H6GtL","frag_card":"Fragrances_frag_card__+EwNM"};